/**
 * AWARE Health — Theme Toggle Component
 * Sun/moon icon button that switches between light and dark themes.
 */

import { useTranslation } from 'react-i18next'
import { useTheme } from '../../contexts/ThemeContext'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const { t } = useTranslation()
  const isDark = theme === 'dark'
  const label = isDark ? t('theme.toLight') : t('theme.toDark')

  return (
    <button
      onClick={toggleTheme}
      title={label}
      aria-label={label}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        borderRadius: 8,
        border: 'none',
        background: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.06)',
        cursor: 'pointer',
        fontSize: 16,
        transition: 'background 0.2s, transform 0.2s',
        color: isDark ? '#f59e0b' : '#475569',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)' }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
    >
      {isDark ? '🌙' : '☀️'}
    </button>
  )
}
